/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_LoadingInputs */

const en_signin_loading = /** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading sign-in options`)
};

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const ar_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const he_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const ur_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const es_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const fr_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const de_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const pt_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const hi_signin_loading = en_signin_loading;

/** @type {(inputs: Signin_LoadingInputs) => LocalizedString} */
const bn_signin_loading = en_signin_loading;

/**
* | output |
* | --- |
* | "Loading sign-in options" |
*
* @param {Signin_LoadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_loading = /** @type {((inputs?: Signin_LoadingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_LoadingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_loading(inputs)
	if (locale === "he") return he_signin_loading(inputs)
	if (locale === "ur") return ur_signin_loading(inputs)
	if (locale === "es") return es_signin_loading(inputs)
	if (locale === "fr") return fr_signin_loading(inputs)
	if (locale === "de") return de_signin_loading(inputs)
	if (locale === "pt") return pt_signin_loading(inputs)
	if (locale === "hi") return hi_signin_loading(inputs)
	if (locale === "bn") return bn_signin_loading(inputs)
	return /** @type {LocalizedString} */ ("Loading sign-in options")
});